"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Dimmer = require("./Dimmer.styled");

var Dimmer = function Dimmer(_ref) {
  var className = _ref.className,
      active = _ref.active,
      fullPage = _ref.fullPage,
      children = _ref.children;
  return active ? /*#__PURE__*/_react.default.createElement(_Dimmer.DimmerContainer, {
    className: className,
    fullPage: fullPage
  }, children) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};

Dimmer.propTypes = {
  className: _propTypes.default.string,
  active: _propTypes.default.bool,
  fullPage: _propTypes.default.bool
};
Dimmer.defaultProps = {
  active: !1,
  fullPage: !1
};
var _default = Dimmer;
exports.default = _default;